import React from 'react';
import _ from 'lodash';
import {
  PageHeader,
  PageHeaderNavigation,
  PageHeaderNavigationLink
} from 'components/clarity-ui';

/**
 * Site Navigation Layout.
 */
class LabelViewerPageHeader extends React.Component {

  renderPageHeaderNavigationLinks (breadcrumbItems) {
    const navigationLinks = [];
    let parentId = 0;
    navigationLinks.push(
      _.isEmpty(breadcrumbItems) ? 'Label Viewer' : (
        <PageHeaderNavigationLink linkTo="/labelViewer" key={'labelViewer-page-header-nav-0'}>
          Label Viewer
        </PageHeaderNavigationLink>
      )
    );
    _.forEachRight(breadcrumbItems, function(item, key) {
      if (key === 0) {
        navigationLinks.push(item.name)
      } else {
        navigationLinks.push(
          <PageHeaderNavigationLink linkTo={`/labelViewer/${item.id}/${parentId}`} key={item.id}>
            { item.name }
          </PageHeaderNavigationLink>
        );
        parentId = item.id;
      }
    });
    return navigationLinks;
  }

  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    const { breadcrumbItems, subhead, title } = this.props;
    return (
      <PageHeader title={title} subhead={subhead}>
        <PageHeaderNavigation>
          { this.renderPageHeaderNavigationLinks(breadcrumbItems) }
        </PageHeaderNavigation>
      </PageHeader>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Icon component
 */
LabelViewerPageHeader.propTypes = {
};

export default LabelViewerPageHeader;



// WEBPACK FOOTER //
// ./src/components/labelViewer/labelViewerPageHeader.component.jsx